import { FoundContent } from '@/components/Css/FoundSection';
import {
  Render,
  Article,
  ChartContainer,
  TableContainer,
  NoticeBox,
} from '@/components/Css/ReportKorea';
import DonutChartComponent from '@/components/DonutChart';
import DonutChartMobileComponent from '@/components/DonutChartMobile';
import Section from '@/components/Section';
import SectionHeader from '@/components/SectionHeader';
import { Tit } from '@/components/Titles';
import React from 'react';

const ReportUnicef2024: React.FC = () => (
  <Render>
    <FoundContent>
      <Section>
        <SectionHeader>
          <h2>
            <Tit size="s1">유니세프 예산 구성비</Tit>
          </h2>
        </SectionHeader>

        <Article>
          <h3 className="sky-bd">
            <Tit size="s2" color="sky">
              2024 수입
            </Tit>
          </h3>
          <div className="m-hide">
            <ChartContainer>
              <DonutChartComponent
                centerText="<span style='font-size: 20px; color:#1cabe2;'>총 수입</span><br><b style='font-size: 36px;letter-spacing: -1.6px;color:#1cabe2'>86억 1,200만</b><b style='font-size:20px;color:#828385'> 달러</b>"
                series={[
                  {
                    name: ``,
                    colorByPoint: true,
                    innerSize: `65%`,
                    type: `pie`,
                    data: [
                      { name: `각국 정부 지원금`, y: 61 },
                      { name: `민간 및 비정부 기구 지원금`, y: 22 },
                      { name: `기구간 조정`, y: 11 },
                      { name: `기타(이자수익, 조달품 등)`, y: 6 },
                    ],
                  },
                ]}
              />
            </ChartContainer>
          </div>
          <div className="pc-hide">
            <ChartContainer>
              <DonutChartMobileComponent
                titleText="<span style='font-size: 16px;color:#1cabe2;'>총 수입</span><br><b style='font-size: 26px;letter-spacing: -1.6px;color:#1cabe2'>86억 1,200만</b><b style='font-size:16px;color:#828385'> 달러</b>"
                series={[
                  {
                    name: ``,
                    colorByPoint: true,
                    innerSize: `50%`,
                    type: `pie`,
                    data: [
                      { name: `각국 정부 지원금`, y: 61 },
                      { name: `민간 및 비정부 기구 지원금`, y: 22 },
                      { name: `기구간 조정`, y: 11 },
                      { name: `기타(이자수익, 조달품 등)`, y: 6 },
                    ],
                  },
                ]}
              />
            </ChartContainer>
          </div>
          <TableContainer>
            <table className="tbl1">
              <colgroup>
                <col className="col1" />
                <col className="col2" />
                <col className="col3" />
              </colgroup>
              <thead>
                <tr>
                  <th>구분</th>
                  <th>금액(백만 달러)</th>
                  <th>비중</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>각국 정부 지원금</td>
                  <td>
                    <p className="price">5,315</p>
                  </td>
                  <td>
                    <p className="price">61.0%</p>
                  </td>
                </tr>
                <tr>
                  <td>민간 및 비정부 기구 지원금</td>
                  <td>
                    <p className="price">1,848</p>
                  </td>
                  <td>
                    <p className="price">22.0%</p>
                  </td>
                </tr>
                <tr>
                  <td>기구간 조정*</td>
                  <td>
                    <p className="price">968</p>
                  </td>
                  <td>
                    <p className="price">11.0%</p>
                  </td>
                </tr>
                <tr>
                  <td>기타(이자수익, 조달품 등)</td>
                  <td>
                    <p className="price">481</p>
                  </td>
                  <td>
                    <p className="price">6.0%</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>계</strong>
                  </td>
                  <td>
                    <p className="price">8,612</p>
                  </td>
                  <td>
                    <p className="price">100.0%</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </TableContainer>
          <NoticeBox>
            <ul className="blit-list">
              <li>
                <strong>기구간 조정 : </strong>유니세프를 포함한 여러 국제기구가
                관리하는 유엔 협력 사업비 중 유니세프 분담액
              </li>
            </ul>
          </NoticeBox>
        </Article>

        <Article>
          <h3 className="sky-bd">
            <Tit size="s2" color="sky">
              2024 지출
            </Tit>
          </h3>

          <div className="tbl-wrap">
            <div className="m-hide">
              <ChartContainer>
                {/* <Tit size="s3-1">총지출 구성비</Tit> */}
                <DonutChartComponent
                  centerText="<span style='font-size: 20px;color:#1cabe2;'>총 지출</span><br><b style='font-size: 36px;letter-spacing: -1.6px;color:#1cabe2'>80억 9,900만</b><b style='font-size:20px;color:#828385'> 달러</b>"
                  series={[
                    {
                      name: ``,
                      colorByPoint: true,
                      innerSize: `65%`,
                      type: `pie`,
                      data: [
                        { name: `사업수행비`, y: 91.1 },
                        { name: `조직 운영비`, y: 5.0 },
                        {
                          name: `국가위원회 모금 및 아동권리증진 활동 투자비`,
                          y: 3.0,
                        },
                        {
                          name: `유엔총회 지정사업 등 특수목적비`,
                          y: 0.4,
                        },
                        { name: `사업수행 및 운영에 대한 감사·감독`, y: 0.4 },
                        { name: `유엔개발협력비`, y: 0.1 },
                      ],
                    },
                  ]}
                />
              </ChartContainer>
            </div>
            <div className="pc-hide">
              <ChartContainer>
                <DonutChartMobileComponent
                  titleText="<span style='font-size: 16px;color:#1cabe2;'>총 지출</span><br><b style='font-size: 26px;letter-spacing: -1.6px;color:#1cabe2'>80억 9,900만</b><b style='font-size:16px;color:#828385'> 달러</b>"
                  series={[
                    {
                      name: ``,
                      colorByPoint: true,
                      innerSize: `50%`,
                      type: `pie`,
                      data: [
                        { name: `사업수행비`, y: 91.1 },
                        { name: `조직 운영비`, y: 5.0 },
                        {
                          name: `국가위원회 모금 및 아동권리증진 활동 투자비`,
                          y: 3.0,
                        },
                        {
                          name: `유엔총회 지정사업 등 특수목적비`,
                          y: 0.4,
                        },
                        { name: `사업수행 및 운영에 대한 감사·감독`, y: 0.4 },
                        { name: `유엔개발협력비`, y: 0.1 },
                      ],
                    },
                  ]}
                />
              </ChartContainer>
            </div>
            <TableContainer>
              <table className="tbl1">
                <colgroup>
                  <col className="col1" />
                  <col className="col2" />
                  <col className="col3" />
                </colgroup>
                <thead>
                  <tr>
                    <th>구분</th>
                    <th>금액(백만 달러)</th>
                    <th>비중</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>사업수행비</td>
                    <td>
                      <p className="price">7,381</p>
                    </td>
                    <td>
                      <p className="price">91.1%</p>
                    </td>
                  </tr>
                  <tr>
                    <td>조직 운영비</td>
                    <td>
                      <p className="price">407</p>
                    </td>
                    <td>
                      <p className="price">5.0%</p>
                    </td>
                  </tr>
                  <tr>
                    <td>국가위원회 모금 및 아동권리증진 활동 투자비</td>
                    <td>
                      <p className="price">239</p>
                    </td>
                    <td>
                      <p className="price">3.0%</p>
                    </td>
                  </tr>
                  <tr>
                    <td>유엔총회 지정사업 등 특수목적비</td>
                    <td>
                      <p className="price">33</p>
                    </td>
                    <td>
                      <p className="price">0.4%</p>
                    </td>
                  </tr>
                  <tr>
                    <td>사업수행 및 운영에 대한 감사·감독</td>
                    <td>
                      <p className="price">29</p>
                    </td>
                    <td>
                      <p className="price">0.4%</p>
                    </td>
                  </tr>
                  <tr>
                    <td>유엔개발협력비</td>
                    <td>
                      <p className="price">10</p>
                    </td>
                    <td>
                      <p className="price">0.1%</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>계</strong>
                    </td>
                    <td>
                      <p className="price">8,099</p>
                    </td>
                    <td>
                      <p className="price">100.0%</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </TableContainer>
          </div>

          <div className="tbl-wrap">
            <div className="m-hide">
              <ChartContainer>
                <Tit size="s3-1">분야별 직접 사업비</Tit>
                <DonutChartComponent
                  centerText="<span style='font-size: 20px;color:#1cabe2;'>분야별 직접 사업비</span><br><b style='font-size: 36px;letter-spacing: -1.6px;color:#1cabe2'>78억 110만</b><b style='font-size:16px;color:#828385'> 달러</b>"
                  series={[
                    {
                      name: ``,
                      colorByPoint: true,
                      innerSize: `65%`,
                      type: `pie`,
                      data: [
                        { name: `생존과 발달`, y: 41.0 },
                        { name: `교육`, y: 20.7 },
                        { name: `안전하고 지속가능한 환경`, y: 15.7 },
                        { name: `어린이 보호`, y: 12.0 },
                        { name: `공평한 기회 보장`, y: 10.6 },
                      ],
                    },
                  ]}
                />
              </ChartContainer>
            </div>
            <div
              className="pc-hide"
              css={`
                margin-top: 96px;
              `}
            >
              <ChartContainer>
                <DonutChartMobileComponent
                  titleText="<span style='font-size: 16px;color: #1cabe2;'>분야별 직접 사업비</span><br><b style='font-size: 26px;letter-spacing: -1.6px;color:#1cabe2'>78억 110만</b><b style='font-size:16px;color:#828385'> 달러</b>"
                  series={[
                    {
                      name: ``,
                      colorByPoint: true,
                      innerSize: `50%`,
                      type: `pie`,
                      data: [
                        { name: `생존과 발달`, y: 41.0 },
                        { name: `교육`, y: 20.7 },
                        { name: `안전하고 지속가능한 환경`, y: 15.7 },
                        { name: `어린이 보호`, y: 12.0 },
                        { name: `공평한 기회 보장`, y: 10.6 },
                      ],
                    },
                  ]}
                />
              </ChartContainer>
            </div>
            <TableContainer>
              <table className="tbl1">
                <colgroup>
                  <col className="col1" />
                  <col className="col2" />
                  <col className="col3" />
                </colgroup>
                <thead>
                  <tr>
                    <th>구분</th>
                    <th>금액(백만 달러)</th>
                    <th>비중</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>생존과 발달</td>
                    <td>
                      <p className="price">3,200.9</p>
                    </td>
                    <td>
                      <p className="price">41.0%</p>
                    </td>
                  </tr>
                  <tr>
                    <td>교육</td>
                    <td>
                      <p className="price">1,616.2</p>
                    </td>
                    <td>
                      <p className="price">20.7%</p>
                    </td>
                  </tr>
                  <tr>
                    <td>안전하고 지속가능한 환경</td>
                    <td>
                      <p className="price">1,225.4</p>
                    </td>
                    <td>
                      <p className="price">15.7%</p>
                    </td>
                  </tr>
                  <tr>
                    <td>어린이 보호</td>
                    <td>
                      <p className="price">934.3</p>
                    </td>
                    <td>
                      <p className="price">12.0%</p>
                    </td>
                  </tr>
                  <tr>
                    <td>공평한 기회 보장</td>
                    <td>
                      <p className="price">824.3</p>
                    </td>
                    <td>
                      <p className="price">10.6%</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>계</strong>
                    </td>
                    <td>
                      <p className="price">7,801.1</p>
                    </td>
                    <td>
                      <p className="price">100.0%</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </TableContainer>
          </div>

          <div className="tbl-wrap">
            <div className="m-hide">
              <ChartContainer>
                <Tit size="s3-1">지역별 직접 사업비</Tit>
                <DonutChartComponent
                  centerText="<span style='font-size: 20px;color:#1cabe2;'>지역별 직접 사업비</span><br><b style='font-size: 36px;letter-spacing: -1.6px;color:#1cabe2'>78억 110만</b><b style='font-size:20px;color:#828385'> 달러</b>"
                  series={[
                    {
                      name: ``,
                      colorByPoint: true,
                      innerSize: `65%`,
                      type: `pie`,
                      data: [
                        { name: `사하라 이남 아프리카`, y: 38.3 },
                        { name: `중동·북아프리카`, y: 22.2 },
                        { name: `아시아`, y: 20.3 },
                        { name: `유럽·중앙아시아`, y: 10.2 },
                        { name: `라틴아메리카·카리브해`, y: 4.9 },
                        { name: `지역간 조정`, y: 4.1 },
                      ],
                    },
                  ]}
                />
              </ChartContainer>
            </div>
            <div
              className="pc-hide"
              css={`
                margin-top: 96px;
              `}
            >
              <ChartContainer>
                <DonutChartMobileComponent
                  titleText="<span style='font-size: 16px;color:#1cabe2;'>지역별 직접 사업비</span><br><b style='font-size: 26px;letter-spacing: -1.6px;color:#1cabe2'>78억 110만</b><b style='font-size:16px;color:#828385'> 달러</b>"
                  series={[
                    {
                      name: ``,
                      colorByPoint: true,
                      innerSize: `50%`,
                      type: `pie`,
                      data: [
                        { name: `사하라 이남 아프리카`, y: 38.3 },
                        { name: `중동·북아프리카`, y: 22.2 },
                        { name: `아시아`, y: 20.3 },
                        { name: `유럽·중앙아시아`, y: 10.2 },
                        { name: `라틴아메리카·카리브해`, y: 4.9 },
                        { name: `지역간 조정`, y: 4.1 },
                      ],
                    },
                  ]}
                />
              </ChartContainer>
            </div>
            <TableContainer>
              <table className="tbl1">
                <colgroup>
                  <col className="col1" />
                  <col className="col2" />
                  <col className="col3" />
                </colgroup>
                <thead>
                  <tr>
                    <th>구분</th>
                    <th>금액(백만 달러)</th>
                    <th>비중</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>사하라 이남 아프리카</td>
                    <td>
                      <p className="price">2,992.3</p>
                    </td>
                    <td>
                      <p className="price">38.3%</p>
                    </td>
                  </tr>
                  <tr>
                    <td>중동·북아프리카</td>
                    <td>
                      <p className="price">1,729.0</p>
                    </td>
                    <td>
                      <p className="price">22.2%</p>
                    </td>
                  </tr>
                  <tr>
                    <td>아시아</td>
                    <td>
                      <p className="price">1,580.6</p>
                    </td>
                    <td>
                      <p className="price">20.3%</p>
                    </td>
                  </tr>
                  <tr>
                    <td>유럽·중앙아시아</td>
                    <td>
                      <p className="price">796.3</p>
                    </td>
                    <td>
                      <p className="price">10.2%</p>
                    </td>
                  </tr>
                  <tr>
                    <td>라틴아메리카·카리브해</td>
                    <td>
                      <p className="price">382.2</p>
                    </td>
                    <td>
                      <p className="price">4.9%</p>
                    </td>
                  </tr>
                  <tr>
                    <td>지역간 조정</td>
                    <td>
                      <p className="price">320.7</p>
                    </td>
                    <td>
                      <p className="price">4.1%</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>계</strong>
                    </td>
                    <td>
                      <p className="price">7,801.1</p>
                    </td>
                    <td>
                      <p className="price">100.0%</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </TableContainer>

            <NoticeBox>
              <ul className="blit-list">
                <li>
                  사업이 다년도에 걸쳐 진행됨에 따라 연도별 수입과 지출 간 차이가
                  발생할 수 있습니다.
                </li>
                <li>
                  출처 :&nbsp;
                  <a
                    href="https://www.unicef.org/reports/unicef-annual-report/2024"
                    className="link-blank"
                    target="_blank"
                  >
                    &nbsp;UNICEF Annual Report 2024
                  </a>
                </li>
              </ul>
            </NoticeBox>
          </div>
        </Article>
      </Section>
    </FoundContent>
  </Render>
);
export default ReportUnicef2024;
